import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../resources/ResourcesStore";
import { injectFromAppLegal } from "../inject";
import { ResponsibleDisclosureNL } from "./ResponsibleDisclosureNL";
import { ResponsibleDisclosureFR } from "./ResponsibleDisclosureFR";
import { ResponsibleDisclosureDE } from "./ResponsibleDisclosureDE";
import { ResponsibleDisclosurePTBR } from "./ResponsibleDisclosurePTBR";
import { ResponsibleDisclosureEN } from "./ResponsibleDisclosureEN";
import { LegalPartialContainerComponent } from "../LegalPartialContainerComponent";

interface IResponsibleDisclosureComponentProps {
    resourcesStore?: IResourcesStore;
}

@injectFromAppLegal<IResponsibleDisclosureComponentProps>(stores => ({
    resourcesStore: stores.resourcesStore,
}))
@observer
export class ResponsibleDisclosureComponent extends React.Component<IResponsibleDisclosureComponentProps> {
    render() {
        const { resourcesStore } = this.props;
        const { currentLanguage, resources } = resourcesStore!;

        let translatedResponsibleDisclosure;

        switch (currentLanguage) {
            case "nl":
                translatedResponsibleDisclosure = <ResponsibleDisclosureNL />;
                break;
            case "fr":
                translatedResponsibleDisclosure = <ResponsibleDisclosureFR />;
                break;
            case "de":
                translatedResponsibleDisclosure = <ResponsibleDisclosureDE />;
                break;
            case "pt-br":
                translatedResponsibleDisclosure = <ResponsibleDisclosurePTBR />;
                break;
            case "en":
            case "es":
            case "no":
            case "it":
            default:
                translatedResponsibleDisclosure = <ResponsibleDisclosureEN />;
                break;
        }

        return <LegalPartialContainerComponent title={resources.ResponsibleDisclosure}>{translatedResponsibleDisclosure}</LegalPartialContainerComponent>;
    }
}
